import BlogArticleService from '@/services/BlogArticleService'

const createBlogArticlesModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    blogArticles: [],
    options: {},
    isLoading: false
  },
  actions: {
    getBlogArticles: ({ commit, state }) => {
      if (state.blogArticles.length && state.options.noPaging) {
        return Promise.resolve()
      }

      return BlogArticleService.getBlogArticles(state.pageSize, state.page, state.options)
        .then((data) => {
          commit('SET_BLOG_ARTICLES', { blogArticles: data.blogArticles })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    getMoreBlogArticles: async ({ commit, state }) => {
      commit('SET_IS_LOADING', true)
      try {
        const data = await BlogArticleService.getBlogArticles(
          state.pageSize,
          state.page + 1,
          state.options
        )
        commit('ADD_BLOG_ARTICLES', { blogArticles: data.blogArticles })
        commit('SET_PAGES', { pages: data.pages })
        commit('SET_TOTAL', { total: data.total })
        commit('SET_PAGE', { page: state.page + 1 })
      } catch (err) {
        console.info(err)
      }
      commit('SET_IS_LOADING', false)
    },
    setPage: ({ commit, dispatch, state }, page) => {
      commit('SET_PAGE', { page })
      if (!state.options.noPaging) {
        dispatch('getBlogArticles')
      }
    },
    setPageSize: ({ commit }, pageSize) => {
      commit('SET_PAGE_SIZE', { pageSize })
    },
    resetOptions: ({ commit }) => {
      commit('RESET_OPTIONS')
    },
    setOption: ({ commit, dispatch }, { key, value }) => {
      commit('SET_OPTION', { key, value })
      commit('SET_PAGE', { page: 1 })
      commit('SET_BLOG_ARTICLES', { blogArticles: [] })
      dispatch('getBlogArticles')
    },
    setOptionOnly: ({ commit }, { key, value }) => {
      commit('SET_OPTION', { key, value })
    }
  },
  getters: {
    blogArticles: (state) => state.blogArticles,
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    },
    hasMorePages: (state) => state.page !== state.pages,
    isLoading: (state) => state.isLoading
  },
  mutations: {
    SET_BLOG_ARTICLES: (state, { blogArticles }) => {
      state.blogArticles = blogArticles
    },
    ADD_BLOG_ARTICLES: (state, { blogArticles }) => {
      state.blogArticles.push(...blogArticles)
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_PAGE: (state, { page }) => {
      state.page = page
    },
    SET_PAGE_SIZE: (state, { pageSize }) => {
      state.pageSize = pageSize
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    },
    RESET_OPTIONS: (state) => {
      state.options = {}
    },
    SET_OPTION: (state, { key, value }) => {
      if (state.options[key] !== value) {
        state.options[key] = value
      }
    },
    SET_IS_LOADING: (state, isLoading) => {
      state.isLoading = isLoading
    }
  }
})

export default createBlogArticlesModule
